import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const TtsDownloadButtonWrapper = styled.div<{
  $isDisabled: boolean
}>`
  padding: 2px;
  border-radius: 4px;
  background: none;

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          /* Keep the button visible and pointer-events on so its tooltip still
             shows on hover — only the download action is suppressed. */
          cursor: not-allowed;
          opacity: 0.4;
        `
      : css`
          cursor: pointer;
          &:hover {
            background-color: ${COLORS.primarySemiLight};
          }
        `}
`
